import { CloseIcon, DeleteIcon, EditIcon, ViewIcon } from "@chakra-ui/icons";
import {
  DrawerFooter,
  Flex,
  Grid,
  GridItem,
  IconButton,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import Spinner from "common/components/spinner/Spinner";
import moment from "moment";
import { useEffect, useState } from "react";
import { BiLink } from "react-icons/bi";
import { Link } from "react-router-dom";
import { getApi } from "common/services/api";
import EditTask from "services/Crm/components/task/editTask";
import { useNavigate } from "react-router-dom";
import { constant } from "common/constant";
import DateFormatter from "common/utils/dateFormater";
import { crmConstant } from "services/Crm/constant";
import CommonDeleteModel from "./commonDeleteModel";
import { toast } from "react-toastify";
import { deleteManyApi } from "common/services/api";

const EventView = (props) => {
  const {
    onClose,
    isOpen,
    info,
    fetchData,
    setAction,
    action,
    access,
    contactAccess,
    leadAccess,
  } = props;
  const [data, setData] = useState();
  const [edit, setEdit] = useState(false);
  const [deleteModel, setDelete] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [selectedValues, setSelectedValues] = useState([]);
  const [menuSelectedDeleteItem, setMenuSelectedDeleteItem] = useState([]);
  const [deleteMany, setDeleteMany] = useState(false);
  const fetchViewData = async () => {
    if (info) {
      setIsLoading(true);
      let result = await getApi(
        "api/task/view/",
        info?.event ? info?.event?.id : info
      );
      setData(result?.data);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchViewData();
  }, [action, info]);

  const handleViewOpen = () => {
    if (data?._id) {
      navigate(`/crm/tasks/taskView/${data?._id}`);
    }
  };


  const handleDeleteTask = async (ids) => {
    try {
      setDeleteMany(false);
      let response = await deleteManyApi("api/task/deleteMany", ids);
      if (response.status === 200) {
        setSelectedValues([]);
        toast.success(
          `${menuSelectedDeleteItem.length > 0
            ? crmConstant.task
            : selectedValues && selectedValues.length > 1
              ? `${crmConstant.task}s`
              : crmConstant.task
          } ${crmConstant.deletedSuccessfully}`
        );
        fetchData()
        return true;
      }
      else {
        return false;
      }
    } catch (error) {
      toast.error("Something went wrong");
      return false;
    } finally {
      setMenuSelectedDeleteItem([]);
      onClose(false)
    }
  };
  function closeDeleteModal() {
    setMenuSelectedDeleteItem([]);
    setDeleteMany(false);
  }
  return (

    <><Modal isOpen={isOpen} size={"md"} isCentered>
      <ModalOverlay />
      <ModalContent maxW={"600px"} marginEnd={"0px"} height={"100%"}>
        <ModalHeader justifyContent="space-between" display="flex">
          {crmConstant.taskInfo}
          <IconButton
            size="xs"
            className="closeIcon"
            onClick={() => onClose(false)}
            icon={<CloseIcon />} />
        </ModalHeader>
        {isLoading ? (
          <Flex
            justifyContent={"center"}
            alignItems={"center"}
            mb={30}
            width="100%"
          >
            <Spinner />
          </Flex>
        ) : (
          <>
            <ModalBody>
              <Grid templateColumns="repeat(6, 1fr)" mb={4} gap={3}>
                <GridItem colSpan={{ base: 2 }}>
                  <Text
                    fontSize="sm"
                    fontWeight="medium"
                    color={"blackAlpha.700"}
                  >
                    {" "}
                    {constant.taskTitle}{" "}
                  </Text>
                </GridItem>
                <GridItem colSpan={{ base: 4 }}>
                  <Text>{data?.title ? data?.title : " - "}</Text>
                </GridItem>
              </Grid>
              <Grid templateColumns="repeat(6, 1fr)" mb={4} gap={3}>
                <GridItem colSpan={{ base: 2 }}>
                  <Text
                    fontSize="sm"
                    fontWeight="medium"
                    color={"blackAlpha.700"}
                  >
                    {" "}
                    {constant.taskRelatedTo}{" "}
                  </Text>
                </GridItem>
                <GridItem colSpan={{ base: 4 }}>
                  <Text>{data?.category ? data?.category : " - "}</Text>
                </GridItem>
              </Grid>
              <Grid templateColumns="repeat(6, 1fr)" mb={4} gap={3}>
                <GridItem colSpan={{ base: 2 }}>
                  <Text
                    fontSize="sm"
                    fontWeight="medium"
                    color={"blackAlpha.700"}
                  >
                    {" "}
                    {constant.assignedTo}{" "}
                  </Text>
                </GridItem>
                <GridItem colSpan={{ base: 4 }}>
                  <Text>
                    {data?.assignmentTo ? (
                      <Link
                        to={
                          contactAccess?.view &&
                          `/crm/contacts/contactView/${data?.assignmentTo}`
                        }
                      >
                        <Text
                          color={
                            contactAccess?.view ? "blue.500" : "blackAlpha.700"
                          }
                          sx={{
                            "&:hover": {
                              color: contactAccess?.view
                                ? "blue.500"
                                : "blackAlpha.700",
                              textDecoration: contactAccess?.view
                                ? "underline"
                                : "none",
                            },
                          }}
                        >
                          {data?.assignmentToName
                            ? data?.assignmentToName
                            : " - "}
                        </Text>
                      </Link>
                    ) : (
                      <Link
                        to={
                          leadAccess?.view &&
                          `/crm/leads/leadView/${data?.assignmentToLead}`
                        }
                      >
                        <Text
                          color={
                            leadAccess?.view ? "blue.500" : "blackAlpha.700"
                          }
                          sx={{
                            "&:hover": {
                              color: leadAccess?.view
                                ? "blue.500"
                                : "blackAlpha.700",
                              textDecoration: leadAccess?.view
                                ? "underline"
                                : "none",
                            },
                          }}
                        >
                          {data?.assignmentToName
                            ? data?.assignmentToName
                            : " - "}
                        </Text>
                      </Link>
                    )}
                  </Text>
                </GridItem>
              </Grid>
              <Grid templateColumns="repeat(6, 1fr)" mb={4} gap={3}>
                <GridItem colSpan={{ base: 2 }}>
                  <Text
                    fontSize="sm"
                    fontWeight="medium"
                    color={"blackAlpha.700"}
                  >
                    {" "}
                    {constant.status}{" "}
                  </Text>
                </GridItem>
                <GridItem colSpan={{ base: 4 }}>
                  <Text textTransform={"capitalize"}>
                    {" "}
                    {data?.status === "todo"
                      ? "To Do"
                      : data?.status === "inProgress"
                        ? "In Progress"
                        : data?.status === "onHold"
                          ? "On Hold"
                          : data?.status || " - "}
                  </Text>
                </GridItem>
              </Grid>
              <Grid templateColumns="repeat(6, 1fr)" mb={4} gap={3}>
                <GridItem colSpan={{ base: 2 }}>
                  <Text
                    fontSize="sm"
                    fontWeight="medium"
                    color={"blackAlpha.700"}
                  >
                    {" "}
                    {constant.taskStart}{" "}
                  </Text>
                </GridItem>
                <GridItem colSpan={{ base: 4 }}>
                  <Text>
                    {data?.start ? DateFormatter(data?.start) : " - "}
                  </Text>
                </GridItem>
              </Grid>
              <Grid templateColumns="repeat(6, 1fr)" mb={4} gap={3}>
                <GridItem colSpan={{ base: 2 }}>
                  <Text
                    fontSize="sm"
                    fontWeight="medium"
                    color={"blackAlpha.700"}
                  >
                    {" "}
                    {constant.taskEnd}{" "}
                  </Text>
                </GridItem>
                <GridItem colSpan={{ base: 4 }}>
                  <Text>{data?.end ? DateFormatter(data?.end) : "-"}</Text>
                </GridItem>
              </Grid>

              <Grid templateColumns="repeat(6, 1fr)" mb={4} gap={3}>
                <GridItem colSpan={{ base: 2 }}>
                  <Text
                    fontSize="sm"
                    fontWeight="medium"
                    color={"blackAlpha.700"}
                  >
                    {" "}
                    {constant.taskLink}{" "}
                  </Text>
                </GridItem>
                <GridItem colSpan={{ base: 4 }}>
                  <Text>
                    {data?.url ? (
                      <a target="_blank" href={data?.url}>
                        <IconButton
                          borderRadius="10px"
                          size="md"
                          icon={<BiLink />}
                        />
                      </a>
                    ) : (
                      "-"
                    )}
                  </Text>
                </GridItem>
              </Grid>


              <Grid templateColumns="repeat(6, 1fr)" mb={4} gap={3}>
                <GridItem colSpan={{ base: 2 }}>
                  <Text
                    fontSize="sm"
                    fontWeight="medium"
                    color={"blackAlpha.700"}
                  >
                    {" "}
                    {constant.taskCreateBy}{" "}
                  </Text>
                </GridItem>
                <GridItem colSpan={{ base: 4 }}>
                  <Text>{data?.createByName ? data?.createByName : " - "}</Text>
                </GridItem>
              </Grid>

              <Grid templateColumns="repeat(6, 1fr)" mb={4} gap={3}>
                <GridItem colSpan={{ base: 2 }}>
                  <Text
                    fontSize="sm"
                    fontWeight="medium"
                    color={"blackAlpha.700"}
                  >
                    {" "}
                    {constant.taskDescription}
                  </Text>
                </GridItem>
                <GridItem colSpan={{ base: 4 }}>
                  <Text>{data?.description ? data?.description : " - "}</Text>
                </GridItem>
              </Grid>

              <Grid templateColumns="repeat(6, 1fr)" mb={4} gap={3}>
                <GridItem colSpan={{ base: 2 }}>
                  <Text
                    fontSize="sm"
                    fontWeight="medium"
                    color={"blackAlpha.700"}
                  >
                    {" "}
                    {constant.taskNotes}{" "}
                  </Text>
                </GridItem>
                <GridItem colSpan={{ base: 4 }}>
                  <Text>{data?.notes ? data?.notes : " - "}</Text>
                </GridItem>
              </Grid>
              <Grid templateColumns="repeat(6, 1fr)" mb={4} gap={3}>
                <GridItem colSpan={{ base: 2 }}>
                  <Text
                    fontSize="sm"
                    fontWeight="medium"
                    color={"blackAlpha.700"}
                  >
                    {" "}
                    {crmConstant.priority}{" "}
                  </Text>
                </GridItem>
                <GridItem colSpan={{ base: 4 }}>
                  <Text>
                    {data?.priority
                      ? crmConstant.priorityList.find(
                          (priorityItem) =>
                            priorityItem.value === data?.priority
                      )?.label || "-"
                      : "-"}
                  </Text>
                </GridItem>
              </Grid>
              <Grid templateColumns="repeat(12, 1fr)" gap={3}>
                {/* <GridItem colSpan={{ base: 12, md: 6 }}>
              <Text
                fontSize="sm"
                fontWeight="medium"
                color={"blackAlpha.700"}
              >
                {" "}
                {constant.taskTitle}{" "}
              </Text>
              <Text fontSize="sm">{data?.title ? data?.title : " - "}</Text>
            </GridItem> */}
                {/* <GridItem colSpan={{ base: 12, md: 6 }}>
              <Text
                fontSize="sm"
                fontWeight="medium"
                color={"blackAlpha.700"}
              >
                {" "}
                {constant.taskRelatedTo}{" "}
              </Text>
              <Text fontSize="sm">
                {data?.category ? data?.category : " - "}
              </Text>
            </GridItem> */}
                {/* <GridItem colSpan={{ base: 12, md: 6 }}>
              <Text
                fontSize="sm"
                fontWeight="medium"
                color={"blackAlpha.700"}
              >
                {" "}
                {constant.taskStart}{" "}
              </Text>
              <Text fontSize="sm">
                {data?.start ? DateFormatter(data?.start) : " - "}
              </Text>
            </GridItem>
            <GridItem colSpan={{ base: 12, md: 6 }}>
              <Text
                fontSize="sm"
                fontWeight="medium"
                color={"blackAlpha.700"}
              >
                {" "}
                {constant.taskEnd}{" "}
              </Text>
              <Text fontSize="sm">
                {data?.end ? DateFormatter(data?.end) : "-"}
              </Text>
            </GridItem> */}
                {/* <GridItem colSpan={{ base: 12, md: 6 }}>
              <Text
                fontSize="sm"
                fontWeight="medium"
                color={"blackAlpha.700"}
              >
                {" "}
                {constant.taskLink}{" "}
              </Text>
              {data?.url ? (
                <a target="_blank" href={data?.url}>
                  <IconButton
                    borderRadius="10px"
                    size="md"
                    icon={<BiLink />}
                  />
                </a>
              ) : (
                "-"
              )}
            </GridItem> */}

                {/* <GridItem colSpan={{ base: 12, md: 6 }}>
              <Text
                fontSize="sm"
                fontWeight="medium"
                color={"blackAlpha.700"}
              >
                {" "}
                {constant.assignmentTo}{" "}
              </Text>
              {data?.assignmentTo ? (
                <Link
                  to={
                    contactAccess?.view &&
                    `/crm/contacts/contactView/${data?.assignmentTo}`
                  }
                >
                  <Text
                    color={
                      contactAccess?.view ? "blue.500" : "blackAlpha.700"
                    }
                    sx={{
                      "&:hover": {
                        color: contactAccess?.view
                          ? "blue.500"
                          : "blackAlpha.700",
                        textDecoration: contactAccess?.view
                          ? "underline"
                          : "none",
                      },
                    }}
                    fontSize="sm"
                  >
                    {data?.assignmentToName
                      ? data?.assignmentToName
                      : " - "}
                  </Text>
                </Link>
              ) : (
                <Link
                  to={
                    leadAccess?.view &&
                    `/crm/leads/leadView/${data?.assignmentToLead}`
                  }
                >
                  <Text
                    color={leadAccess?.view ? "blue.500" : "blackAlpha.700"}
                    sx={{
                      "&:hover": {
                        color: leadAccess?.view
                          ? "blue.500"
                          : "blackAlpha.700",
                        textDecoration: leadAccess?.view
                          ? "underline"
                          : "none",
                      },
                    }}
                    fontSize="sm"
                  >
                    {data?.assignmentToName
                      ? data?.assignmentToName
                      : " - "}
                  </Text>
                </Link>
              )}
            </GridItem> */}
                {/* <GridItem colSpan={{ base: 12, md: 6 }}>
              <Text
                fontSize="sm"
                fontWeight="medium"
                color={"blackAlpha.700"}
              >
                {" "}
                {constant.taskCreateBy}{" "}
              </Text>
              <Text fontSize="sm">
                {data?.createByName ? data?.createByName : " - "}
              </Text>
            </GridItem> */}
                {/* <GridItem colSpan={{ base: 12 }}>
              <Text
                fontSize="sm"
                fontWeight="medium"
                color={"blackAlpha.700"}
              >
                {" "}
                {constant.taskDescription}
              </Text>
              <Text fontSize="sm">
                {data?.description ? data?.description : " - "}
              </Text>
            </GridItem> */}
                {/* <GridItem colSpan={{ base: 12 }}>
              <Text
                fontSize="sm"
                fontWeight="medium"
                color={"blackAlpha.700"}
              >
                {" "}
                {constant.taskNotes}{" "}
              </Text>
              <Text fontSize="sm">{data?.notes ? data?.notes : " - "}</Text>
            </GridItem> */}
              </Grid>
            </ModalBody>
            <DrawerFooter>
              {access?.view ||
                (user?.role === "superAdmin" && (
                  <IconButton
                    variant="outline"
                    colorScheme={"green"}
                    onClick={() => handleViewOpen()}
                    borderRadius="10px"
                    size="md"
                    icon={<ViewIcon />}
                  />
                ))}
              {/* {access?.update ||
              (user?.role === "superAdmin" && (
                <IconButton
                  variant="outline"
                  onClick={() => setEdit(true)}
                  ml={3}
                  borderRadius="10px"
                  size="md"
                  icon={<EditIcon />}
                />
              ))} */}
              {access?.delete ||
                (user?.role === "superAdmin" && (
                  <IconButton
                    colorScheme="red"
                    onClick={() => {
                      setDeleteMany(true);
                      setSelectedValues([data?._id]);
                      setMenuSelectedDeleteItem([data?._id]);
                    }}
                    ml={3}
                    borderRadius="10px"
                    size="md"
                    icon={<DeleteIcon />} />
                ))}

              {/* <EditTask
              setAction={setAction}
              isOpen={edit}
              onClose={setEdit}
              viewClose={onClose}
              id={info?.event ? info?.event?.id : info}
              from="view"
            /> */}
              {/* <DeleteTask fetchData={props.fetchData} isOpen={deleteModel} onClose={setDelete} viewClose={onClose} url='api/task/delete/' method='one' id={info?.event ? info?.event?.id : info} /> */}
            </DrawerFooter>
          </>
        )}
      </ModalContent>
    </Modal>
      <CommonDeleteModel
        isOpen={deleteMany}
        onClose={() => closeDeleteModal()}
        type={menuSelectedDeleteItem.length > 0
          ? crmConstant.task
          : selectedValues && selectedValues.length > 1
            ? `${crmConstant.task}s`
            : crmConstant.task}
        handleDeleteData={handleDeleteTask}
        ids={selectedValues} /></>

  );
};

export default EventView;
